import React, { useEffect, useRef, useState } from "react";

const CHATBUBBLE_IMG =
    "https://chatvolt-bucket.s3.us-east-1.amazonaws.com/agents/cm8czqxnr06iqeutjaav478ni/cmagzypyr000035716bw5fvif.png?timestamp=1746807302297";

const ChatBubble = () => {
    const [chatActive, setChatActive] = useState(false);
    const [showHint, setShowHint] = useState(false);
    const chatWindowContentRef = useRef(null);

    useEffect(() => {
        // Show hint after 5 seconds
        const hintTimeout = setTimeout(() => setShowHint(true), 5000);
        // Hide hint after 10 seconds
        const hideTimeout = setTimeout(() => setShowHint(false), 15000);

        // Inject Chatvolt script when chat opens
        if (chatActive && chatWindowContentRef.current) {
            // Prevent duplicate script injection
            if (!chatWindowContentRef.current.querySelector("chatvolt-chatbox-standard")) {
                const script = document.createElement("script");
                script.type = "module";
                script.innerHTML = `
          import Chatbox from 'https://cdn.jsdelivr.net/npm/@chatvolt/embeds@latest/dist/chatbox/index.js';
          Chatbox.initStandard({
            agentId: 'cm8czqxnr06iqeutjaav478ni',
          });
        `;
                chatWindowContentRef.current.appendChild(script);

                // Add the chatbox element
                const chatbox = document.createElement("chatvolt-chatbox-standard");
                chatbox.style.width = "100%";
                chatbox.style.height = "calc(74vh - 100px)";
                chatWindowContentRef.current.appendChild(chatbox);
            }
        }

        return () => {
            clearTimeout(hintTimeout);
            clearTimeout(hideTimeout);
        };
    }, [chatActive]);

    return (
        <>
            {/* Inline styles for the chat bubble */}
            <style>{`
        .chat-bubble {
          position: fixed;
          bottom: 5vh;
          right: 5vw;
          background-color: #0A3A26;
          border-radius: 50%;
          width: 80px;
          height: 80px;
          box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transition: transform 0.3s ease, box-shadow 0.3s ease;
          z-index: 1000;
        }
        .chat-bubble img {
          width: 80px;
          height: 80px;
        }
        .chat-bubble:hover {
          transform: scale(1.1);
          box-shadow: 0 10px 20px rgba(0, 0, 0, 0.3);
        }
        .chat-window {
          position: fixed;
          bottom: 10vh;
          right: 5vw;
          width: 90vw;
          max-width: 450px;
          height: calc(100vh - 20vh);
          background-color: #ffffff;
          border-radius: 15px;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
          overflow: hidden;
          transform: scale(0);
          transform-origin: bottom right;
          transition: transform 0.3s ease;
          display: flex;
          flex-direction: column;
          z-index: 999;
        }
        .chat-window.active {
          transform: scale(1);
        }
        .chat-window-header {
          padding: 15px;
          background-color: #EB5E3F;
          color: #ffffff;
          font-size: 18px;
          font-weight: bold;
          display: flex;
          align-items: center;
          justify-content: space-between;
        }
        .chat-window-header button {
          background: none;
          border: none;
          color: #ffffff;
          cursor: pointer;
          font-size: 20px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .chat-hint {
          position: fixed;
          bottom: 14vh;
          right: 7vw;
          background-color: #ffffff;
          color: #000000;
          padding: 10px 15px;
          border-radius: 15px;
          box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
          font-size: 14px;
          max-width: 250px;
          z-index: 999;
          opacity: 0;
          transition: opacity 0.5s ease;
        }
        .chat-hint.show {
          opacity: 1;
        }
      `}</style>

            {/* Chat Bubble */}
            <div className="chat-bubble" onClick={() => setChatActive(true)}>
                <img src={CHATBUBBLE_IMG} alt="Chat Icon" />
            </div>

            {/* Floating Hint */}
            <div className={`chat-hint${showHint ? " show" : ""}`}>
                If you need any information, I'm here to help!
            </div>

            {/* Chat Window */}
            <div className={`chat-window${chatActive ? " active" : ""}`}>
                <div className="chat-window-header">
                    <span>Premium Tours</span>
                    <button onClick={() => setChatActive(false)}>×</button>
                </div>
                <div className="chat-window-content" ref={chatWindowContentRef}></div>
            </div>
        </>
    );
};

export default ChatBubble;